import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface PageAction {
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  onClick: () => void;
}

export interface NavigationState {
  currentPageTitle: string;
  currentPageAction?: PageAction;
  
  // Actions
  setPageInfo: (title: string, action?: PageAction) => void;
  clearPageAction: () => void;
}

const useNavigationStore = create<NavigationState>()(
  devtools(
    (set) => ({
      currentPageTitle: 'GodMode',
      currentPageAction: undefined,

      setPageInfo: (title: string, action?: PageAction) => {
        set({ 
          currentPageTitle: title,
          currentPageAction: action 
        });
      },

      clearPageAction: () => {
        set({ currentPageAction: undefined });
      }
    }),
    {
      name: 'navigation-store'
    }
  )
);

export { useNavigationStore };